/** LITTA fulfilment statuses that count as unassigned on the assignment board. */
export const LITTA_UNASSIGNED_CARRIER_KEYS = [
    'ready_to_offer',
    'offered',
    'offer_rejected',
] as const

export type LittaUnassignedCarrierStatusKey =
    (typeof LITTA_UNASSIGNED_CARRIER_KEYS)[number]

export function isLittaUnassignedCarrierStatus(
    statusKey: string | null,
): statusKey is LittaUnassignedCarrierStatusKey {
    return (
        statusKey !== null &&
        (LITTA_UNASSIGNED_CARRIER_KEYS as readonly string[]).includes(
            statusKey,
        )
    )
}
